const $ = jQuery;

$(document).ready(function() {
    const el = $('.blog-cta-bar');
    if (!el || el.length === 0) {
        return;
    }

    const startOffset = $('article.post .post-image').length > 0 ?
        $('article.post .post-image').offset().top + $('article.post .post-image').height() :
        $('article.post .post-header').offset().top + $('article.post .post-header').height();
    const endOffset = $('.post-wrapper .post-author-card').length > 0 ?
        $('.post-wrapper .post-author-card').offset().top + $('.post-wrapper .post-author-card').height() :
        $('.post-wrapper .post-main').offset().top + $('.post-wrapper .post-main').height();

    $(document).scroll(function() {
        const el = $('.blog-cta-bar');
        const scroll = $(document).scrollTop() + $(window).height() / 2;
        if (scroll < startOffset || scroll > endOffset) {
            el.addClass('blog-cta-bar-hidden');
        } else {
            el.removeClass('blog-cta-bar-hidden');
        }
    });
});



// WEBPACK FOOTER //
// ./src/js/blog-cta-bar.js